module.exports = __webpack_public_path__ + "assets/hide-black-2b04c4e202131e38e53a08f1fb95ea37.svg";